import { type Transifex } from 'types'

type ENLANG = 'en'
type NONENLANG = Exclude<Transifex.Languages, 'en'>

type QuoteRecord = Record<ENLANG, string> & Partial<Record<NONENLANG, string>>

export const quoteAshley: QuoteRecord = {
    en: 'ashley-w.jpg',
    da: 'silas.jpg',
    de: 'silas.jpg',
    nb: 'silas.jpg',
    nl: 'silas.jpg',
    sv: 'silas.jpg',
    cs: 'pavel.jpg',
    pl: 'pavel.jpg',
    ru: 'pavel.jpg',
    tr: 'proje.jpg',
}

export const quoteOrganisePrioritise: QuoteRecord = {
    en: 'maria-r.jpg',
    cs: 'tomasz.jpg',
    tr: 'umit.jpg',
}

export const quotePedro: QuoteRecord = {
    en: 'pedro-v.jpg',
    cs: 'jens.jpg',
    da: 'jens.jpg',
    de: 'jens.jpg',
    nl: 'jens.jpg',
    nb: 'jens.jpg',
    sv: 'jens.jpg',
    tr: '1L8d2E0i.jpg',
}

export const quoteRamon: QuoteRecord = {
    en: 'ramon.jpg',
    da: 'ag.jpg',
    de: 'ag.jpg',
    nb: 'ag.jpg',
    nl: 'ag.jpg',
    ru: 'ag.jpg',
    sv: 'ag.jpg',
}

export const quoteIvan: QuoteRecord = {
    en: 'ivan-j.jpg',
    de: 'renel.jpg',
    fr: 'renel.jpg',
    'pt-BR': 'renel.jpg',
}
